export const SIGN_UP_PATH = '/auth/register';

/** True when the ticket is an invitation for someone without an account yet:
 *  Clerk's invitation link says so in `__clerk_status`. */
export const ticketNeedsSignUp = (search: string) =>
  new URLSearchParams(search).get('__clerk_status') === 'sign_up';
